import { render } from "./MainToolbar.vue?vue&type=template&id=6a6825e2&scoped=true&ts=true"
import script from "./MainToolbar.vue?vue&type=script&lang=ts"
export * from "./MainToolbar.vue?vue&type=script&lang=ts"

import "./MainToolbar.vue?vue&type=style&index=0&id=6a6825e2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6825e2"]])

export default __exports__